import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { SplitReveal, FadeUp } from "../components/SplitReveal";
import { useLanguage } from "../lib/i18n";

export function Faq() {
  const { t } = useLanguage();
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="relative bg-[#0F1115] px-6 py-24 md:px-12 md:py-40" data-testid="faq-section">
      <div className="mx-auto max-w-3xl">
        <div className="mb-14">
          <FadeUp>
            <p className="heading mb-4 text-sm not-italic tracking-[0.3em] text-hars-orange">{t.faq.kicker}</p>
          </FadeUp>
          <SplitReveal text={t.faq.title} className="heading text-4xl text-white md:text-6xl" />
        </div>

        <div className="divide-y divide-white/10 border-y border-white/10">
          {t.faq.items.map((item, i) => {
            const active = open === i;
            return (
              <div key={i} data-testid={`faq-item-${i}`}>
                <button
                  onClick={() => setOpen(active ? -1 : i)}
                  data-cursor
                  aria-expanded={active}
                  className="flex w-full items-center justify-between gap-6 py-6 text-left"
                >
                  <span className={`font-inter text-lg font-medium transition-colors ${active ? "text-hars-orange" : "text-white"}`}>
                    {item.q}
                  </span>
                  <span className={`shrink-0 text-hars-orange transition-transform duration-300 ${active ? "rotate-45" : ""}`}>
                    <Plus size={22} />
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {active && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: "easeInOut" }}
                      className="overflow-hidden"
                    >
                      <p className="pb-6 font-inter text-base text-hars-muted">{item.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
